export const LANGUAGES = [
  {
    logo: "/images/Italian.svg",
    code: "it",
    name: "Italian",
  },
  {
    logo: "/images/English.svg",
    code: "en",
    name: "English",
  },
];

export const DEFAULT_LANGUAGE_NAME = "Italian";

export const getStoredLanguageName = () => {
  const stored = localStorage.getItem("language");
  if (stored && LANGUAGES.some((lang) => lang.name === stored)) {
    return stored;
  }
  return DEFAULT_LANGUAGE_NAME;
};

export const getLanguageByName = (name) =>
  LANGUAGES.find((lang) => lang.name === name) || LANGUAGES[0];

export const getInitialLanguage = () => getLanguageByName(getStoredLanguageName());

export const isEnglishLanguage = (language) => {
  if (language && typeof language === "object" && language.name) {
    return language.name === "English";
  }

  const name = typeof language === "string" ? language : getStoredLanguageName();
  return name === "English";
};

export const getAppLanguage = () => getStoredLanguageName();

export const getLanguageNameFromApiValue = (apiValue) => {
  if (!apiValue) return DEFAULT_LANGUAGE_NAME;

  const normalized = String(apiValue).trim().toLowerCase();

  if (normalized === "english" || normalized === "English" || normalized === "en") return "English";
  if (normalized === "italy" || normalized === "Italy" || normalized === "italian" || normalized === "it") {
    return "Italian";
  }

  return DEFAULT_LANGUAGE_NAME;
};

export const getLanguageNameFromUser = (user) => {
  return getLanguageNameFromApiValue(user?.language);
}

export const syncGoogleTranslateWithLanguage = (language) => {
  const languageName =
    language && typeof language === "object" && language.name
      ? language.name
      : typeof language === "string"
        ? language
        : getStoredLanguageName();

  const selectBox = document.querySelector("#google_translate_element select");
  if (!selectBox) return;

  const targetValue = languageName === "English" ? "en" : "it";
  if (selectBox.value !== targetValue) {
    selectBox.value = targetValue;
    selectBox.dispatchEvent(new Event("change"));
  }
};
